import { useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setDestination } from "../../modules/reducers/destination/destination";
import { sanitizeHttpUrl } from "../../utils";

const useControlQuickMenu = ({ needSelectBranch, openModal }) => {
  const dispatch = useDispatch();
  const swiperRef = useRef(null);

  const { pathname } = useLocation();

  const getMenuItemProps = (item) => {
    const { value, requiresStore, label } = item;

    if (needSelectBranch && requiresStore) {
      return {
        onClick: () => {
          openModal();
          dispatch(setDestination({ from: pathname, to: value, label }));
        },
      };
    }

    const externalHref = sanitizeHttpUrl(value);
    if (externalHref) {
      return {
        href: externalHref,
        onClick: () => {
          dispatch(setDestination({ from: pathname, to: externalHref, label }));
        },
      };
    }

    if (value?.startsWith("/")) {
      return { to: value };
    }

    return {};
  };

  return { getMenuItemProps, swiperRef };
};

export default useControlQuickMenu;
